import state from './state';
import mutations from './mutations';
import actions from './actions';

const imChat = {
  state: {
    ...state
  },
  mutations: {
    ...mutations
  },
  actions: {
    ...actions
  }
}

export default imChat


// WEBPACK FOOTER //
// ./src/store/modules/im/index.js